module.exports = __webpack_public_path__ + "img/gongshui-4.0d899eff.png";